<div *ngFor="let category of mainCategories">
    <button mat-menu-item (click)="changeCategory($event)">
        <span>{{category.name}}</span>
    </button>
     <div *ngIf="category.hasSubCategory" class="sub-category">
        <app-category-list [categories]="categories" [categoryParentId]="category.id" (change)="changeCategory($event)"></app-category-list>
    </div>
</div>